const slash = (value) =>
  `${String(value || "").trim().replace(/\/+$/, "")}/`;

const DEFAULT_API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://linaimmo.com/api/"
    : "http://192.168.1.5:5000/api/";

export const API_BASE_URL = slash(
  process.env.REACT_APP_API_BASE_URL ||
    DEFAULT_API_BASE_URL
);

const origin = API_BASE_URL.replace(/api\/$/i, "");

export const PHOTO_BASE_URL = slash(
  process.env.REACT_APP_PHOTO_BASE_URL ||
    `${origin}photos/`
);

export const SIGNALR_URL = (
  process.env.REACT_APP_SIGNALR_URL ||
  `${origin}notificationHub`
).replace(/\/+$/, "");

export const API_URL = API_BASE_URL;

export const variables = {
  API_URL: API_BASE_URL,
  PHOTO_URL: PHOTO_BASE_URL,
  SIGNALR_URL,
};

export function photoUrl(path, folder = "") {
  if (!path) return "/image-placeholder.svg";

  if (
    /^https?:\/\//i.test(path) ||
    /^(blob:|data:image\/)/i.test(path)
  ) {
    return path;
  }

  const clean = String(path)
    .replace(/\\/g, "/")
    .replace(/^\/+/, "")
    .replace(/^photos\//i, "");

  const directory = String(folder)
    .replace(/\\/g, "/")
    .replace(/^\/+|\/+$/g, "");

  return `${PHOTO_BASE_URL}${
    directory && !clean.includes("/")
      ? `${directory}/`
      : ""
  }${clean}`;
}